import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetResultVersions = (periodId) => {
  const query = useApiQuery(
    ['courseAssignmentResultVersions', periodId],
    'schools',
    client => client.get(`/current-organization/course-assignment/periods/${periodId}/results`),
    { enabled: !!periodId },
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    versions: query.data?.versions ?? [],
    error: query.error,
    refetch: query.refetch
  }
}
